var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col" },
    [
      _c("p", { staticClass: "step-caption ft-bld" }, [
        _vm._v("Enter content information & tags"),
      ]),
      _vm._v(" "),
      _c("InputWrapper", {
        attrs: { placeholder: "Content name", "max-chars": 18 },
        model: {
          value: _vm.Global.newContentOverlay.name,
          callback: function ($$v) {
            _vm.$set(_vm.Global.newContentOverlay, "name", $$v)
          },
          expression: "Global.newContentOverlay.name",
        },
      }),
      _vm._v(" "),
      _c("AutoTagsWrapper", {
        attrs: { placeholder: "Tags" },
        model: {
          value: _vm.Global.newContentOverlay.tags,
          callback: function ($$v) {
            _vm.$set(_vm.Global.newContentOverlay, "tags", $$v)
          },
          expression: "Global.newContentOverlay.tags",
        },
      }),
      _vm._v(" "),
      _c("TextareaWrapper", {
        attrs: { placeholder: "Content description" },
        model: {
          value: _vm.Global.newContentOverlay.description,
          callback: function ($$v) {
            _vm.$set(_vm.Global.newContentOverlay, "description", $$v)
          },
          expression: "Global.newContentOverlay.description",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nxt-out" }, [
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("nxt")
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }